export const colors = ["Black & Gray", "Color", "Both"];

export const types = {
  tattoo: ["New", "Cover-up", "Fix-up", "Touch-up"],
  "permanent-makeup": ["New", "Fix-up", "Touch-up"],
};

export const styles = {
  tattoo: [
    "3D X-Ray",
    "Abstract",
    "American Traditional",
    "Anatomical (Muscular / Skeletal)",
    "Anime",
    "Asian New School",
    "Asian Traditional",
    "Bio-Mechanical",
    "Bio-Organic",
    "Blackwork",
    "Cartoon",
    "Celtic",
    "Chicano",
    "Comic",
    "Dotwork",
    "Fine Line",
    "Geometric",
    "Gothic",
    "Greek",
    "Horror",
    "Mandala",
    "Neo-Traditional",
    "New School",
    "Patriotic",
    "Pointillism",
    "Polynesian / Samoan",
    "Pop art",
    "Portrait",
    "Realism",
    "Religious",
    "Roman",
    "Script/Lettering",
    "Simple / Minimalist",
    "Statue",
    "Surrealism",
    "Trash Polka",
    "Tribal",
    "UV / Glow-in-the-Dark",
    "Viking",
    "Watercolor",
    "Other",
  ],
  "permanent-makeup": [
    "Eyebrow (Solid)",
    "Eyebrow (Ombre)",
    "Eyebrow (Microblading)",
    "Eyeliner",
    "Lip Liner",
    "Lips",
  ],
};
